import { render, staticRenderFns } from "./ticketList.vue?vue&type=template&id=622cc160"
import script from "./ticketList.vue?vue&type=script&lang=js"
export * from "./ticketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports